import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { getPreferredOdpOrgId } from '@em-helpers';
import { IcSettingsService } from '@item-cache';
import { Observable, filter, map } from 'rxjs';

import { environment } from '../../../environments/environment';

export const OnboardingGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const needsOnboardingSignal = inject(IcSettingsService).needsOnboardingSignal.asReadonly();

  // Wait for initialization to be sure that the needsOnboarding is set to a final value
  return toObservable(inject(IcSettingsService).isInitializedSignal).pipe(
    filter((isInitialized) => isInitialized),
    map(() => {
      if (needsOnboardingSignal()) {
        window.location.href = environment.vismaEmpmanUrl + '#/' + getPreferredOdpOrgId();
        return false;
      }
      return true;
    }),
  );
};

export const SegmentGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const segmentErrorSignal = inject(IcSettingsService).segmentErrorSignal.asReadonly();

  // Wait for initialization to be sure that the segmentError is set to a final value
  return toObservable(inject(IcSettingsService).isInitializedSignal).pipe(
    filter((isInitialized) => isInitialized),
    map(() => {
      if (segmentErrorSignal()) {
        router.navigate(['segment-error']);
        return false;
      }
      return true;
    }),
  );
};
